import { useState, useEffect } from 'react';
import offlineEngine from '../services/offlineEngine';

export function useSyncStatus() {
  const [status, setStatus] = useState({
    online: true, pending: 0, failed: 0, syncing: false, mode: 'auto',
  });

  useEffect(() => {
    const unsub = offlineEngine.subscribe(s => setStatus(s));
    return unsub;
  }, []);

  return status;
}
